// --- Debug helpers ---
var HP_DEBUG = false; // set to false to silence
function dlog() {
    if (!HP_DEBUG) return;
    try {
        console.log.apply(console, arguments);
    } catch (e) {
    }
}

function dgroup(title) {
    if (!HP_DEBUG) return;
    try {
        console.groupCollapsed(title);
    } catch (e) {
    }
}

function dgroupEnd() {
    if (!HP_DEBUG) return;
    try {
        console.groupEnd();
    } catch (e) {
    }
}

(function () {
    // Support multiple configurator sections on a page
    var sections = document.querySelectorAll('.hp-configurator[data-section-id]');
    if (!sections.length) return;

    sections.forEach(initSection);

    // ---------------- core init per section ----------------
    function initSection(section) {
        var id = section.getAttribute('data-section-id');

        var requiredLabel = section.getAttribute('data-required-label') || 'Benötigte Maße inkl. Puffer';
        var strengthDefault = section.getAttribute('data-strength-default') || 'medium';

        // ----- multi-step wiring (1: Maße, 2: Geräuschpegel, 3: Stärke, 4: Ergebnis) -----
        var step1 = section.querySelector('#hp-step1-' + id);
        var step2 = section.querySelector('#hp-step2-' + id);
        var step3 = section.querySelector('#hp-step3-' + id);
        var resultsStep = section.querySelector('#hp-results-' + id);
        var curStep = 1;

        function showStep(n) {
            curStep = n;
            if (step1) step1.hidden = (n !== 1);
            if (step2) step2.hidden = (n !== 2);
            if (step3) step3.hidden = (n !== 3);
            if (resultsStep) resultsStep.hidden = (n !== 4);
        }

        showStep(1);

        // preselect default strength
        var strengthInput = section.querySelector('input[name="hp-strength-' + id + '"][value="' + strengthDefault + '"]');
        if (strengthInput) strengthInput.checked = true;

        var defaults = {
            sizeName: (section.getAttribute('data-size-default') || 'Größe (HxBxT)').toLowerCase(),
            noiseName: (section.getAttribute('data-noise-default') || 'Schallschutz').toLowerCase()
        };

        var buffers = {
            h: parseInt(section.getAttribute('data-buf-h'), 10) || 0,
            wSide: parseInt(section.getAttribute('data-buf-w-side'), 10) || 0,
            d: parseInt(section.getAttribute('data-buf-d'), 10) || 0
        };

        // Read product JSON blocks
        var productNodes = section.querySelectorAll('.hp-products .hp-product');
        var products = [];
        productNodes.forEach(function (node) {
            var json = safeParseJSON(node.textContent);
            if (!json) return;

            var sizeName = (node.getAttribute('data-size-name') || defaults.sizeName).toLowerCase();
            var noiseName = (node.getAttribute('data-noise-name') || defaults.noiseName).toLowerCase();

            products.push({
                id: json.id,
                title: json.title || json.handle || 'Unbenannt',
                handle: json.handle,
                url: (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'products/' + json.handle,
                image: json.featured_image ? json.featured_image.src : null,
                options: (Array.isArray(json.options) && json.options.length
                    ? json.options.map(String)
                    : (Array.isArray(json.options_with_values)
                        ? json.options_with_values.map(function (o) {
                            return String(o.name || '');
                        })
                        : [])),
                sizeName: sizeName,
                noiseName: noiseName,
                variants: (json.variants || []).map(function (v) {
                    return {
                        id: v.id,
                        title: v.title,
                        available: !!v.available,
                        price: v.price,
                        compare_at_price: v.compare_at_price,
                        image: v.featured_image ? v.featured_image.src : (json.featured_image ? json.featured_image.src : null),
                        options: v.options
                    };
                })
            });
        });

        var errBox = section.querySelector('#hp-err-' + id);

        function showError(msg) {
            if (errBox) {
                errBox.hidden = false;
                errBox.textContent = msg;
            }
        }

        function clearError() {
            if (errBox) {
                errBox.hidden = true;
                errBox.textContent = '';
            }
        }

        function $(sel) {
            return section.querySelector(sel);
        }

        // --- helper parsing ---
        function safeParseJSON(txt) {
            try {
                return JSON.parse(txt);
            } catch (e) {
                return null;
            }
        }

        function escapeHtml(str) {
            return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;')
                .replace(/>/g, '&gt;').replace(/\"/g, '&quot;').replace(/'/g, '&#039;');
        }

        function findOptionIndex(product, wanted) {
            var idx = -1;
            var w = (wanted || '').toLowerCase();
            (product.options || []).forEach(function (opt, i) {
                var n = String(opt || '').toLowerCase();
                if (n === w || n.includes(w) || w.includes(n)) idx = i;
            });
            if (idx === -1 && product.options.length === 1) idx = 0;
            return idx;
        }

        function autodetectSizeIndex(product) {
            if (!product.variants) return -1;
            for (var vi = 0; vi < product.variants.length; vi++) {
                var v = product.variants[vi];
                for (var oi = 0; oi < v.options.length; oi++) {
                    if (/(\d{2,4}).*(\d{2,4}).*(\d{2,4})/.test(v.options[oi])) return oi;
                }
            }
            return -1;
        }

        function parseDimsFromSizeValue(val) {
            if (!val) return null;
            var m = String(val).match(/(\d{2,4})\D+(\d{2,4})\D+(\d{2,4})/);
            return m ? {h: +m[1], w: +m[2], d: +m[3]} : null;
        }

        function parseDbFromNoise(val) {
            var s = String(val).toLowerCase();
            if (/(ohne|basis|0\s*d[bB]|rückwand)/.test(s)) return 0;
            var nums = s.match(/\d{1,2}/g);
            if (!nums) return 0;
            return Math.max.apply(null, nums.map(Number));
        }

        // --- step control buttons ---
        var next1 = $('#hp-next1-' + id);
        var prev2 = $('#hp-prev2-' + id);
        var next2 = $('#hp-next2-' + id);
        var prev3 = $('#hp-prev3-' + id);
        var next3 = $('#hp-next3-' + id);
        var prev4 = $('#hp-prev4-' + id);

        if (next1) next1.addEventListener('click', function () {
            var h = parseInt($('#hp-h-' + id).value, 10);
            var w = parseInt($('#hp-w-' + id).value, 10);
            var d = parseInt($('#hp-d-' + id).value, 10);
            if (!h || !w || !d) {
                showError('Bitte Höhe, Breite und Tiefe eingeben.');
                return;
            }
            clearError();
            showStep(2);
        });

        if (prev2) prev2.addEventListener('click', function () {
            showStep(1);
        });
        if (next2) next2.addEventListener('click', function () {
            var noise = (section.querySelector('input[name="hp-noise-' + id + '"]:checked') || {}).value || 'no';
            if (noise === 'no') {
                runConfigurator(0);
                showStep(4);
            } else {
                showStep(3);
            }
        });

        if (prev3) prev3.addEventListener('click', function () {
            showStep(2);
        });
        if (next3) next3.addEventListener('click', function () {
            runConfigurator();
            showStep(4);
        });
        if (prev4) prev4.addEventListener('click', function () {
            var noise = (section.querySelector('input[name="hp-noise-' + id + '"]:checked') || {}).value || 'no';
            showStep(noise === 'no' ? 2 : 3);
        });

        // --- main logic ---
        function runConfigurator(forceDbMin) {
            var h = parseInt($('#hp-h-' + id).value, 10);
            var w = parseInt($('#hp-w-' + id).value, 10);
            var d = parseInt($('#hp-d-' + id).value, 10);
            if (!h || !w || !d) {
                showError('Bitte Maße eingeben.');
                return;
            }

            clearError();
            var strength = (section.querySelector('input[name="hp-strength-' + id + '"]:checked') || {}).value || strengthDefault;
            var requiredDbMin = (typeof forceDbMin === 'number') ? forceDbMin : (strength === 'max' ? 8 : 6);

            var needH = h + buffers.h;
            var needW = w + 2 * buffers.wSide;
            var needD = d + buffers.d;

            renderResults({h: needH, w: needW, d: needD}, requiredDbMin);
        }

        function matchVariant(product, c) {
            var sizeIdx = findOptionIndex(product, product.sizeName);
            if (sizeIdx === -1) sizeIdx = autodetectSizeIndex(product);
            var noiseIdx = findOptionIndex(product, product.noiseName);
            var out = null, minVol = Infinity;

            (product.variants || []).forEach(function (v) {
                var dims = parseDimsFromSizeValue(v.options[sizeIdx]);
                if (!dims) return;
                if (c.h > dims.h || c.w > dims.w || c.d > dims.d) return;
                if (c.requiredDbMin && noiseIdx > -1) {
                    var db = parseDbFromNoise(v.options[noiseIdx]);
                    if (db < c.requiredDbMin) return;
                }
                var vol = dims.h * dims.w * dims.d;
                if (vol < minVol) {
                    minVol = vol;
                    out = {v: v, dims: dims};
                }
            });
            return out;
        }

        function renderResults(dims, requiredDbMin) {
            var wrap = $('#hp-cards-' + id);
            var sizeOut = $('#hp-sizeout-' + id);
            wrap.innerHTML = '';
            var any = false;
            products.forEach(function (p) {
                var pick = matchVariant(p, {h: dims.h, w: dims.w, d: dims.d, requiredDbMin: requiredDbMin});
                if (!pick) return;
                any = true;
                var v = pick.v;
                var el = document.createElement('article');
                el.className = 'hp-card';
                el.innerHTML =
                    '<a class=\"hp-img\" href=\"' + p.url + '\">' +
                    (v.image ? '<img src=\"' + v.image + '\" alt=\"' + escapeHtml(p.title) + '\" loading=\"lazy\">' : '') +
                    '</a>' +
                    '<div class=\"hp-body\">' +
                    '<h4>' + escapeHtml(p.title) + '</h4>' +
                    '<div>' + escapeHtml(v.title) + '</div>' +
                    '<div>Empfohlene Größe</div>' +
                    '<div class="hp-price">' + formatMoney(v.price) + '</div>' +
                    '<button class=\"hp-primary hp-add\" data-vid=\"' + v.id + '\">' + (v.available ? 'In den Warenkorb' : 'Ausverkauft') + '</button>' +
                    '</div>';
                wrap.appendChild(el);
            });
            if (sizeOut) sizeOut.textContent = requiredLabel + ': ' + dims.h + ' × ' + dims.w + ' × ' + dims.d + ' mm';
            if (!any) wrap.innerHTML = '<p class=\"hp-hint\">Keine passenden Varianten gefunden.</p>';

            wrap.querySelectorAll('.hp-add').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var vid = btn.getAttribute('data-vid');
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({id: vid, quantity: 1})
                    }).then(() => {
                        btn.textContent = 'Hinzugefügt';
                    }).catch(() => {
                        btn.textContent = 'Fehler';
                    });
                });
            });
        }

        function formatMoney(cents) {
            try {
                if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                    return Shopify.formatMoney(cents);
                }
            } catch (e) {
            }
            // fallback: convert cents → Euro with comma
            var num = (cents / 100).toFixed(2);
            return num.replace('.', ',') + ' €';
        }
    }
})();